import { render } from "./ProCongrats.vue?vue&type=template&id=2ef9c665"
import script from "./ProCongrats.vue?vue&type=script&lang=ts"
export * from "./ProCongrats.vue?vue&type=script&lang=ts"
script.render = render

export default script